import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs, { type Dayjs } from 'dayjs'
import type { ChargeReconciliationRow } from '../../../Reports/types/chargeReconciliation'

export {
  formatDisplayName,
  formatMinutes
} from '../reconciliationUtils'

export const RECONCILIATION_CHARGE_MAX_PAST_MONTHS = 12
export const RECONCILIATION_CHARGE_MAX_RANGE_MONTHS = 6

export const getChargeReconciliationRangeDisabledDate: NonNullable<
  RangePickerProps['disabledDate']
> = (current, info) => {
  const today = dayjs().startOf('day')
  const c = current.startOf('day')

  if (c.isAfter(today, 'day')) {
    return true
  }

  const earliest = today
    .subtract(RECONCILIATION_CHARGE_MAX_PAST_MONTHS, 'month')
    .startOf('day')
  if (c.isBefore(earliest, 'day')) {
    return true
  }

  const from = info?.from
  if (!from) {
    return false
  }

  const f = from.startOf('day')
  const windowStart = f.subtract(
    RECONCILIATION_CHARGE_MAX_RANGE_MONTHS,
    'month'
  )
  const windowEnd = f.add(RECONCILIATION_CHARGE_MAX_RANGE_MONTHS, 'month')

  if (c.isBefore(windowStart, 'day') || c.isAfter(windowEnd, 'day')) {
    return true
  }

  return false
}

export function isValidChargeReconciliationDateRange(
  start: Dayjs,
  end: Dayjs
): boolean {
  const s = start.startOf('day')
  const e = end.startOf('day')
  const today = dayjs().startOf('day')
  if (e.isBefore(s, 'day')) {
    return false
  }
  const earliestStart = today
    .subtract(RECONCILIATION_CHARGE_MAX_PAST_MONTHS, 'month')
    .startOf('day')
  if (s.isBefore(earliestStart, 'day')) {
    return false
  }
  if (e.isAfter(today, 'day')) {
    return false
  }
  const maxEnd = s
    .add(RECONCILIATION_CHARGE_MAX_RANGE_MONTHS, 'month')
    .startOf('day')
  if (e.isAfter(maxEnd, 'day')) {
    return false
  }
  return true
}

export function rowKey(row: ChargeReconciliationRow): string {
  return row.rotaInstanceId
}

export function calcChargeAmount(ratePerHour: number, minutes: number): number {
  return Math.round(ratePerHour * (minutes / 60) * 100) / 100
}

export function sortTeamMemberNames(names: string[]): string[] {
  return [...names].sort((a, b) => a.localeCompare(b))
}

export function sortTeamMembers<T extends { name: string }>(members: T[]): T[] {
  return [...members].sort((a, b) => a.name.localeCompare(b.name))
}
